import dayjs from "dayjs";
import {BaechaWorkDayModalType} from "./BaechaList2.interface";
import {CarType} from "../../types/Type";

export const onOpenMapByCoordinates = ({ lat, lon }: { lat?: number, lon?: number }) => {
	if (!lat || !lon) return;

	window.open(`https://www.google.com/maps/place/${lat},${lon}/@${lat},${lon},11z`, '_blank');
};

export const getMMDDHHmmStr = (date: Date) => {
	const MMDDStr = dayjs(date).tz('Asia/Seoul').format('MM-DD');
	const HHmmStr = dayjs(date).tz('Asia/Seoul').format('HH:mm')
	return `${MMDDStr} ${HHmmStr}`;
};


export const getModalTitle = (modalType: BaechaWorkDayModalType, dayNum: number) => {
	switch (modalType) {
		case 'ADD':
			return `${dayNum}일차 작업 추가`;
		case 'EDIT':
			return `${dayNum}일차 작업 상세 수정`;
		case 'DELETE':
			return `${dayNum}일차 작업 삭제`;
		case 'DONE':
			return `${dayNum}일차 작업 완료`;
		default:
			return '';
	}
};

export const getModalOkBtnStr = (mode: BaechaWorkDayModalType) => {
	if (mode === 'ADD') return '추가하기';
	if (mode === 'EDIT') return '수정하기';
	if (mode === 'DELETE') return '삭제하기';
	if (mode === 'DONE') return '완료하기';
	return '';
};

export const SMALL_CAR_TYPES = new Set<CarType>([
	'1t','2t','3t','1-2t','1-3t','2-3t','5t'
]);

export const BIG_CAR_TYPES = new Set<CarType>([
	'54m','58m','75m',
	'5t_over','54m_over','58m_over',
	'28m','40m',
	'60m','70m',
]);

export const getPriceByType = (target: any, priceType?: string) => {
	if (!target) return 0;
	if (priceType === 'old') return target.oldPrice ?? 0;
	if (priceType === 'mid') return target.midPrice ?? 0;
	return target.newPrice ?? 0;
};

export const getRegionPrefix = (str?: string) => {
	if (!str || str.length === 0) return '';

	let region = str.split(' ')[0];
	region = region.replaceAll('충청북도', '충북');
	region = region.replaceAll('충청남도', '충남');
	region = region.replaceAll('전라남도', '전남');
	region = region.replaceAll('전라북도', '전북');
	region = region.replaceAll('경상남도', '경남');
	region = region.replaceAll('경상북도', '경북');
	return region
		.replaceAll('특별시', '')
		.replaceAll('광역시', '')
		.replaceAll('특별자치시', '')
		.replaceAll('특별자치도', '')
		.replaceAll('도', '')
		.trim()
};

export const convertCarTypeIntoNum = (carType: CarType): number => {
	if (carType === '1t') return 1;
	if (carType === '2t') return 2;
	if (carType === '3t') return 3;
	if (carType === '5t') return 5;
	if (carType === '54m') return 54;
	if (carType === '58m') return 58;
	if (carType === '75m') return 75;
	// 굴절
	if (carType === '28m') return 28;
	if (carType === '40m') return 40;
	if (carType === '60m') return 60;
	if (carType === '70m') return 70;
	return 0;
}

export const getIsCanCallPass = (baechaCarType: CarType, userCarType: CarType) => {
	const userCarTypeNum = convertCarTypeIntoNum(userCarType);

	if (baechaCarType === '1t') return userCarTypeNum <= 3; // 1톤 발주는 1, 2, 3톤만 지원 가능
	if (baechaCarType === '2t') return userCarTypeNum === 2 || userCarTypeNum === 3; // 2톤 발주는 2, 3톤 지원 가능
	if (baechaCarType === '3t') return userCarTypeNum === 3 || userCarTypeNum === 5; // 3톤 발주는 3, 5톤만 지원 가능
	if (baechaCarType === '1-2t') return userCarTypeNum <= 2; // 1-2톤 발주는 1, 2톤만 지원 가능
	if (baechaCarType === '2-3t') return userCarTypeNum === 2 || userCarTypeNum === 3; // 2-3톤 발주는 2, 3톤만 지원 가능
	if (baechaCarType === '1-3t') return userCarTypeNum <= 3; // 1-3톤 발주는 1, 2, 3톤만 지원 가능
	if (baechaCarType === '5t') return userCarTypeNum >= 5; // 5톤 발주는 5톤, 54M, 58M, 75M 지원 가능
	if (baechaCarType === '54m') return userCarTypeNum >= 54; // 54M 발주는 54M, 58M, 75M 지원 가능
	if (baechaCarType === '58m') return userCarTypeNum >= 58; // 58M 발주는 58M, 75M 지원 가능
	if (baechaCarType === '75m') return userCarTypeNum >= 75; // 75M 발주는 75M 지원 가능
	if (baechaCarType === '54m_over') return userCarTypeNum >= 54;
	if (baechaCarType === '58m_over') return userCarTypeNum >= 58;
	// 굴절: 무조건 동종 차량만 지원 가능
	if (baechaCarType === '28m') return userCarTypeNum === 28;
	if (baechaCarType === '40m') return userCarTypeNum === 40;
	if (baechaCarType === '60m') return userCarTypeNum === 60;
	if (baechaCarType === '70m') return userCarTypeNum === 70;
	return false;
}
